import { Observable } from 'rxjs';

export interface AllocationViewActionInterface {
  loaded$: Observable<boolean>;

  setInitialState(): void;
  loadAll?<LoadParamsType>(params?: LoadParamsType): void;
  execute?<ExecuteParamsType>(params?: ExecuteParamsType): void;
}

export interface AllocationViewCombinedActionInterface {
  loaded$: Observable<boolean>;
  responseData$: Observable<unknown>;

  setInitialState(): void;
  loadAll?<LoadParamsType>(params?: LoadParamsType): void;
  execute?<ExecuteParamsType>(params?: ExecuteParamsType): void;
}
